import { Type, Static } from '@sinclair/typebox'

export const DataRequestStandardTB = Type.Literal('standard')
export const DataRequestAdvancedTB = Type.Literal('advanced')

export const DataRequestTB = Type.Union([
  DataRequestStandardTB,
  DataRequestAdvancedTB
])
export type DataRequestT = Static<typeof DataRequestTB>

export const VisionOrgPreferencesTB = Type.Object({
  useClientReferenceId: Type.Optional(Type.Boolean()),
  showExportOnDashboard: Type.Optional(Type.Boolean()),
  supportLinkViaRegisterFlow: Type.Optional(Type.Boolean()),
  requireClientReferenceIdDuringRegister: Type.Optional(Type.Boolean()),
  dataRequestType: Type.Optional(DataRequestTB),
})
export type VisionOrgPreferencesT = Static<typeof VisionOrgPreferencesTB>

export const VisionOrganisationDTOTB = Type.Object({
  id: Type.String(),
  name: Type.String(),
  logo_url: Type.Optional(Type.String()),
  icon_small_url: Type.Optional(Type.String()),
  theme: Type.Optional(Type.Any()), // TODO: what is TB representation of "JSON" type?
  sharedInvitationOrgIds: Type.Optional(Type.Array(Type.String())),
  preferences: Type.Optional(VisionOrgPreferencesTB)
})
export type VisionOrganisationDTOT = Static<typeof VisionOrganisationDTOTB>

export const VisionOrganisationCreateTB = Type.Omit(VisionOrganisationDTOTB, [
  'id',
  'preferences'
])
export type VisionOrganisationCreateDTOT = Static<typeof VisionOrganisationCreateTB>

export const VisionOrganisationSummaryTB = Type.Object({
  id: Type.String(),
  name: Type.String(),
  logo_url: Type.Optional(Type.String()),
  icon_small_url: Type.Optional(Type.String())
})
export type VisionOrganisationSummaryT = Static<typeof VisionOrganisationSummaryTB>

export const VisionOrganisationBasicTB = Type.Object({
  id: Type.String(),
  name: Type.String(),
  icon_small_url: Type.Optional(Type.String()),
  logo_url: Type.Optional(Type.String()),
  supportLinkViaRegisterFlow: Type.Optional(Type.Boolean()),
  requireClientReferenceIdDuringRegister: Type.Optional(Type.Boolean()),
  consentTerms: Type.Optional(Type.String())
})
export type VisionOrganisationBasicT = Static<typeof VisionOrganisationBasicTB>

export const VisionOrgThemeTB = Type.Object({
  primaryBrandColor: Type.Optional(Type.String()),
  primaryButtonText: Type.Optional(Type.String()),
  primaryBrandColorFaded: Type.Optional(Type.String()),
  fontColor: Type.Optional(Type.String()),
  sidebarBg: Type.Optional(Type.String()),
  contentBg: Type.Optional(Type.String()),
  secondaryColor: Type.Optional(Type.String()),
  secondaryTextColor: Type.Optional(Type.String()),
  sidebarActiveColor: Type.Optional(Type.String()),
  sidebarMenuTextActiveColor: Type.Optional(Type.String()),
  sidebarMenuTextColor: Type.Optional(Type.String()),
  borderRadius: Type.Optional(Type.String()),
  outlineColor: Type.Optional(Type.String()),
  cardBackground: Type.Optional(Type.String()),
  colorInfoBg: Type.Optional(Type.String()),
  colorInfoBorder: Type.Optional(Type.String()),
  tableHoverBackground: Type.Optional(Type.String()),
  logoutBtnColor: Type.Optional(Type.String()),
  logoutBtnText: Type.Optional(Type.String()),
  dashboard: Type.Optional(Type.Object({
    grains: Type.Optional(Type.Boolean()),
    sheep: Type.Optional(Type.Boolean()),
    beef: Type.Optional(Type.Boolean()),
    wool: Type.Optional(Type.Boolean()),
    feedlot: Type.Optional(Type.Boolean()),
    processor: Type.Optional(Type.Boolean()),
  }))
})
export type VisionOrgThemeT = Static<typeof VisionOrgThemeTB>
